module.exports = __webpack_public_path__ + "fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/fb.png
// module id = 534
// module chunks = 0